BaseModel = require './base_model.coffee'

class global.Company extends BaseModel
  @ATTRIBUTES = {
    id: {}
    name: {}
    email_domain: {}
    email_domain_verified: {}
    dkim_value: {}
    dkim_selector: {}
    active: true
    number_of_regular_users: {}
    number_of_monitoring_managers: {}
    voip_service: {}
    voip_plan_status: {}
    email_service: {}
    voip_plan_seconds_left: {}
    voip_plan_max_duration: {}
    cpf_active: false
    cnpj_active: false
  }

  @ASSOCIATIONS = {
    account_setting: -> AccountSetting
    custom_fields: -> CustomField
    plivo_setting: -> PlivoSetting
    twilio_setting: -> TwilioSetting
    rd_carousel: -> Carousel
    sp_carousel: -> Carousel
    hs_carousel: -> Carousel
  }

  @SERIALIZABLE_ATTRIBUTES = ['id', 'name', 'email_domain', 'active', 'plivo_setting_attributes', 'twilio_setting_attributes', 'email_service']

  @SERIALIZABLE_ASSOCIATIONS = ['account_setting', 'plivo_setting', 'twilio_setting']

  isActive: ->
    @active

  account_setting_options: ->
    account_settings: [
      { value: { name: 'basic' , max_number_of_regular_users: 3 }, text: 'Básico (até 3 usuários)' },
      { value: { name: 'developer' , max_number_of_regular_users: 8 }, text: 'Profissional (3-8 usuários)' },
      { value: { name: 'premium' , max_number_of_regular_users: 12 }, text: 'Premium (9-12 usuários)' },
      { value: { name: 'enterprise' , max_number_of_regular_users: null }, text: 'Customizado (mais de 12 usuários)' }
    ]

  available_roles: ->
    roles = []
    if @number_of_regular_users < @account_setting.max_number_of_regular_users || !@account_setting || @account_setting instanceof Array
      roles.push 'manager'
      roles.push 'seller'
      roles.push 'sdr'
    if @number_of_monitoring_managers < @account_setting.max_number_of_monitoring_managers || !@account_setting || @account_setting instanceof Array
      roles.push 'monitoring_manager'
    roles

  isPlivo: ->
    @voip_service == 'plivo'

  isTwilio: ->
    @voip_service == 'twilio'

  isVoipExceeded: ->
    @voip_plan_status == 'exceeded'

  serialize: ->
    serialized = super
    delete serialized['plivo_setting_attributes'] unless @isPlivo()
    delete serialized['twilio_setting_attributes'] unless @isTwilio()

    serialized

  isSparkpost: ->
    @email_service == 'sparkpost'

  isNylas: ->
    @email_service == 'nylas'



// WEBPACK FOOTER //
// ./src/models/company.coffee